import * as React from 'react';
import * as RX from 'reactxp';

import { colors } from '../../../utils/styles';

class Close extends React.Component<{style?: {[key: string]: any}}> {

  constructor(props) {
    super(props);
  }

  public render() {
    return (
      <svg height={35} width={35} viewBox='0 0 24 24' style={{ ...this.props.style }}>
        <rect fill={colors.primary} width='58' height='58'/>
        <polygon fill={colors.white} points='14.4,12 20.4,5.9 18,3.5 11.9,9.6 5.8,3.5 3.4,5.9 9.6,12 3.5,18.1 5.9,20.5 12,14.4 18.1,20.5 20.5,18 '/> {/*tslint:disable-line*/}
      </svg>
    );
  }
}

export default Close;



// WEBPACK FOOTER //
// ./src/modules/svgs/close/index.web.tsx